import { useContext, useEffect, useState } from 'react';
import { setSession } from '../../store/utility';
import { UserContext } from 'context/User/UserContext';
import { getLegacyMetadata } from './_api';

const WithLegacyApp = ({ children }) => {
	const [sessionSet, setSessionSet] = useState(false);
	/**
	 * @type {import('context/User/UserContext').ContextUser}
	 */
	const contextUser = useContext(UserContext);
	const user = contextUser.userInfo.impersonationProfile ?? contextUser.userInfo.userProfile;

	useEffect(() => {
		const setLegacyMetadata = async esoID => {
			try {
				const response = await getLegacyMetadata(esoID);
				for (let key in response) {
					await setSession(key, response[key]);
				}
			} catch {
				//in the event of error, set what we know
				await setSession('LoggedOnUser', esoID);
				await setSession('LoggedOnUserESO', esoID);
			} finally {
				setSessionSet(true);
			}
		};

		if (user.ID) {
			setLegacyMetadata(
				user.ESOID
			);
		}
	}, [user]);
	return <>{sessionSet ? children : null}</>;
};

export default WithLegacyApp;
